import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorInterceptor } from './core/interceptors/error-interceptor.service';
import { GlobalErrorHandlerService } from './core/error-handlers/global-error-handler.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';
import { authInterceptor } from './core/interceptors/auth-interceptor.service';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { provideMarkdown } from 'ngx-markdown';
import { MainScrollViewportScroller } from './core/services/main-scroll-viewport-scroller';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        // Disabled because scroll restoration is handled manually per-route via
        // ScrollService/NavigationService. Enabling it here makes the custom
        // MainScrollViewportScroller scroll #main-scroll to the top on imperative
        // "back" navigations, clobbering the saved list scroll position.
        scrollPositionRestoration: 'disabled',
        anchorScrolling: 'enabled',
      })
    ),
   provideAuth0({
      domain: environment.auth0.domain,              // MUST be your custom domain (e.g., auth.wsy.com)
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin + '/resolving',
        audience: environment.auth0.audience
      },
      cacheLocation: 'memory',
      useRefreshTokens: true,
      useRefreshTokensFallback: true
    }),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark'
        }
      },
      ripple: true
    }),
    provideHttpClient(
      withInterceptors([authInterceptor])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    },
    MessageService,
    provideMarkdown(),
    { provide: ViewportScroller, useClass: MainScrollViewportScroller },
  ],
};
